import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  id: null,
  requestedService: '',
  description: '',
  projectId: '',
  useForCustomerRateEstimates: false,
  shipCodeMappingEstimateRules: {
    estimateFixedPrice: null,
    estimatePercentageMarkup: null,
    minOrderValueToShowEstimate: null,
    maxOrderValueToShowEstimate: null,
    minWeightToShowEstimate: null,
    maxWeightToShowEstimate: null
  },
  clientNotes: null
};

let defaultFilters = {
  status: null,
  projectId: null,
  requestedService: null,
  description: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,
  state: () => ({ ...genedStore.state }),
  mutations: { ...genedStore.mutations },
  getters: { ...genedStore.getters },
  actions: { ...genedStore.actions }
};
